/*
 * Copyright 2018-2025 CommScope, Inc., All rights reserved.
 *
 * This program is confidential and proprietary to CommScope, Inc. (CommScope), and
 * may not be copied, reproduced, modified, disclosed to others, published or used, in
 * whole or in part, without the express prior written permission of CommScope.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { isEqual } from 'lodash';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import { createShowPanelSelector } from 'app/redux/app';
import { vertSSIDFilterSelector } from 'app/redux/filters';
import {
  hierarchyNodeSelected,
  hierarchySelector,
  rootNodeSelector,
  selectedPathSelector
} from 'app/redux/hierarchy';
import {
  setSMBWifiReportGenerated,
  fetchSMBProWifiReport,
  smbProWifiReportFetchStateSelector,
  smbProWifiReportGeneratedSelector,
  generateInProgressSelector
} from 'app/redux/reports';
import { isSpecificNodeType } from 'app/components/layout/components/sidebar/utils';
import GenerateSMBProWifiReport from './generate-smbprowifi-report';

class SMBReportIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      smbWifiReport: false
    };
  }

  componentDidUpdate = prevProps => {
    const { selectedPath, setSMBWifiReportGenerated } = this.props;
    const { selectedPath: prevPath } = prevProps;
    const nodeChanged =
      isSpecificNodeType(selectedPath, 'zonename') &&
      !isEqual(prevPath.id, selectedPath.id);

    if (nodeChanged) {
      this.setState({ smbWifiReport: false }, () => {
        setSMBWifiReportGenerated();
      });
    }
  };

  toggleGenerateReport = report => () =>
    this.setState(prevState => ({ [report]: !prevState[report] }));

  render = () => {
    const {
      fetchSMBProWifiReport,
      isSMBReportGenerated,
      setSMBWifiReportGenerated,
      showGenerateSmbWifiReport
    } = this.props;

    const { smbWifiReport } = this.state;

    return (
      <Fragment>
        {showGenerateSmbWifiReport && (
          <GenerateSMBProWifiReport
            {...this.props}
            handleGenerateReport={params =>
              fetchSMBProWifiReport({ ...params, download: true })
            }
            showGenerate={smbWifiReport}
            toggleGenerate={this.toggleGenerateReport('smbWifiReport')}
            updateTableReportStatus={setSMBWifiReportGenerated}
            isSMBReportGenerated={isSMBReportGenerated}
          />
        )}
      </Fragment>
    );
  };
}

SMBReportIndex.propTypes = {
  smbProWifiReportData: PropTypes.object,
  smbProWifiReportFetchState: PropTypes.object,
  fetchSMBProWifiReport: PropTypes.func,
  setSMBWifiReportGenerated: PropTypes.func,
  setSwitchReportGenerated: PropTypes.func,
  hierarchyNodeSelected: PropTypes.func,
  hierarchy: PropTypes.object,
  selectedPath: PropTypes.object,
  vertSSIDFilter: PropTypes.object.isRequired,
  rootNode: PropTypes.object,
  isSMBReportGenerated: PropTypes.bool,
  showGenerateSmbWifiReport: PropTypes.bool
};

const mapStateToProps = createSelector(
  createShowPanelSelector('ReportsGenerateSMBWifiReport'),
  smbProWifiReportFetchStateSelector,
  generateInProgressSelector,
  hierarchySelector,
  selectedPathSelector,
  vertSSIDFilterSelector,
  rootNodeSelector,
  smbProWifiReportGeneratedSelector,
  (
    showGenerateSmbWifiReport,
    smbProWifiReportFetchState,
    generateInProgress,
    hierarchy,
    selectedPath,
    vertSSIDFilter,
    rootNode,
    isSMBReportGenerated
  ) => ({
    showGenerateSmbWifiReport,
    smbProWifiReportFetchState,
    generateInProgress,
    hierarchy,
    selectedPath,
    vertSSIDFilter,
    rootNode,
    isSMBReportGenerated
  })
);

const mapDispatchToProps = {
  hierarchyNodeSelected,
  fetchSMBProWifiReport,
  setSMBWifiReportGenerated
};

export default connect(mapStateToProps, mapDispatchToProps)(SMBReportIndex);
